import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';
import { useResponsesStore } from 'state/zustand/assessmentResponses';
import { useComparisonCacheStore } from 'state/zustand/comparisonCache';

/**
 * Interface for logout response
 */
export interface LogoutResponse {
  detail: string;
}

/**
 * Hook for logging out using TanStack React Query
 */
export const useLogout = () => {
  const { openToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await apiClient.post<LogoutResponse>('/auth/logout/');
      return response.data;
    },
    onSuccess: () => {
      // Clear all cached data to prevent stale data for next user
      queryClient.clear();

      // Clear Zustand persisted stores
      useResponsesStore.getState().clearResponses();
      useComparisonCacheStore.getState().clearCache();

      openToast({
        show: true,
        heading: 'Success',
        text: 'Successfully logged out!',
        type: 'info',
        timeOut: 5000,
      });
    },
    onError: (err: any) => {
      const errorMessage = err?.response?.data?.message || 'Failed to logout';
      openToast({
        show: true,
        heading: 'Logout Failed',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};